import { debounce, isEqual, uniqueId } from 'lodash';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import styles from './HorizontalSlider.module.scss';
import { useHorizontallyDraggableElement } from './useHorizontallyDraggableElement';

function HorizontalSlider(props) {
    const { className = '', children, visibleTabs: preferredVisibleTabs = 0, centerIndex, onChange } = props,
        [tabPositions, setTabPositions] = useState([]),
        ref = useRef(),
        [CID] = useState(uniqueId('HorizontalSlider')),
        [containerSize, setContainerSize] = useState([0, 0]),
        [sliderSize, setSliderSize] = useState([0, 0]),
        { leftPosition, onTouchStart, isAtLeft, isAtRight, tabsInViewport, canSlide } = useHorizontallyDraggableElement(containerSize, sliderSize, tabPositions, centerIndex),
        [ready, setReady] = useState(),
        componentIsReady = useCallback(
            debounce(() => setReady(true), 25),
            []
        ),
        visibleTabs = preferredVisibleTabs > 0 ? Math.min(preferredVisibleTabs, tabPositions.length) : null,
        adjustTabSize = visibleTabs && containerSize[0] > 0;

    // Notify changes to parent
    useEffect(() => {
        if (onChange) {
            onChange({ isAtLeft, isAtRight, tabsInViewport, canSlide });
        }
    }, [onChange, tabsInViewport]);

    // Update children positions
    const updateDimensions = useCallback(() => {
        if (!ref.current) return;

        const newContainerSize = [ref.current.offsetWidth, ref.current.firstChild.offsetHeight];
        setContainerSize((containerSize) => (isEqual(newContainerSize, containerSize) ? containerSize : newContainerSize));

        const newSliderSize = [ref.current.firstChild.offsetWidth, ref.current.firstChild.offsetHeight];
        setSliderSize((sliderSize) => (isEqual(newSliderSize, sliderSize) ? sliderSize : newSliderSize));

        componentIsReady();

        if (newContainerSize[0] > 0) {
            let newTabPositions = [...ref.current.firstChild.children].map((el) => el.offsetLeft);
            setTabPositions((tabPositions) => (isEqual(newTabPositions, tabPositions) ? tabPositions : newTabPositions));
        }
    }, []);
    useEffect(updateDimensions);
    useEffect(() => {
        window.addEventListener('resize', updateDimensions);
        return () => window.removeEventListener('resize', updateDimensions);
    }, [updateDimensions]);

    return (
        <>
            <div id={CID} className={[className,styles.HorizontalSlider, ready ? styles.ready : '', adjustTabSize ? '' : styles.noTabSize].join(' ')} ref={ref} style={{ height: containerSize[1] }}>
                <div className={[ styles.wrapper].join(' ')} style={{ left: leftPosition, minWidth: containerSize[0] }} onTouchStart={onTouchStart}>
                    {children}
                </div>
            </div>
            {adjustTabSize ? (
                <style>
                    {`
                    #${CID} .${styles.wrapper} {
                        min-width: ${containerSize[0]}px;
                    }
                    #${CID} .${styles.wrapper} > *{
                        width: ${containerSize[0] / visibleTabs}px;
                    }
                `}
                </style>
            ) : null}
        </>
    );
}

export default HorizontalSlider;
